import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import { useStore } from "../../connect";

import { MAIN_PAGE_QUERY_PARAM } from "../../consts";

import strings from "../../locales/strings";

import styles from "./LoginButtons.scss";

const cx = classnames.bind(styles);

const LoginButtons = ({ hideLoginButton, hideRegisterButton }) => {
  const { baseUrl, profile, header } = useStore();

  const onUserRegister = (event) => {
    event.preventDefault();
    event.stopPropagation();

    profile.onUserRegister(baseUrl);
  };

  const onLoginOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();

    profile.onLoginOpen({
      next: window.location.href,
      additionalQueryParams: header.isMainPage ? MAIN_PAGE_QUERY_PARAM : null,
    });
  };

  const onRegistrationOpen = (event) => {
    event.preventDefault();

    profile.onRegistrationOpen({
      next: window.location.href,
      additionalQueryParams: header.isMainPage ? MAIN_PAGE_QUERY_PARAM : null,
    });
  };

  const handleRegistrationClick = (event) => {
    const isLoginPage = /id\.ati\.s.*\/login/.test(window.location.href);

    if (profile.registrationPopupCookie && isLoginPage) {
      onRegistrationOpen(event);
    } else {
      onUserRegister(event);
    }
  };

  return (
    <div className={cx("buttons")}>
      {!hideLoginButton && (
        <button
          onClick={onLoginOpen}
          data-name="login-button"
          className={cx(
            "header-login", // класс для скрытия кнопки на id.ati.su
            "header-login-button",
            "glz-button",
            "glz-is-small",
            "glz-is-primary"
          )}
        >
          <span className={cx("mobile-button-text")}>{strings.login}</span>
          <span className={cx("desktop-button-text")}>{strings.toLogin}</span>
        </button>
      )}
      {!hideRegisterButton && (
        <button
          onClick={handleRegistrationClick}
          data-name="register-button"
          className={cx(
            "header-register", // класс для скрытия кнопки на id.ati.su
            "header-registration-button",
            "glz-button",
            "glz-is-small",
            "glz-is-secondary"
          )}
        >
          <span className={cx("mobile-button-text")}>
            {strings.registration}
          </span>
          <span className={cx("desktop-button-text")}>
            {strings.toRegister}
          </span>
        </button>
      )}
    </div>
  );
};

LoginButtons.propTypes = {
  hideLoginButton: PropTypes.bool,
  hideRegisterButton: PropTypes.bool,
};

export default observer(LoginButtons);
